import { AclAssetModuleResourceType } from '@y42/acl/models';

export const AclAssetModuleResourceTypeToLabel: Record<AclAssetModuleResourceType, string> = {
  [AclAssetModuleResourceType.Integrations]: 'Integrations',
  [AclAssetModuleResourceType.Models]: 'Models',
  [AclAssetModuleResourceType.Visualizations]: 'Visualizations',
  [AclAssetModuleResourceType.Orchestrations]: 'Orchestrations',
  [AclAssetModuleResourceType.DataContracts]: 'Data Contracts',
  [AclAssetModuleResourceType.DataExports]: 'Data Exports',
  [AclAssetModuleResourceType.Alerts]: 'Alerts',
  [AclAssetModuleResourceType.Lineage]: 'Lineage',
};
